import { Injectable } from '@angular/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';
import { Router } from '@angular/router';
import { ApiService } from '../api/api.service';
import { Capacitor } from '@capacitor/core';
import { SqliteStorageService } from '../sqlite-storage/sqlite-storage.service';
import { DriverResponse } from 'src/app/models/driver.model';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {

  private pendingRoute: string | null = null;

  constructor(
    private readonly apiService: ApiService,
    private readonly router: Router,
    private readonly sqlite: SqliteStorageService
  ) { }

  async requestPushPermission() {
    const status = await PushNotifications.checkPermissions();

    if (status.receive !== 'granted') {
      const request = await PushNotifications.requestPermissions();
      if (request.receive !== 'granted') return;
    }

    await PushNotifications.register();
  }

  initializeListeners() {

    // When notification is tapped (Foreground/Background/Killed)
    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (action: any) => {

        const data = action.notification?.data;

        if (data?.deepLinkTarget == 'appointment') {
          this.pendingRoute = '/appointments';
        } else {
          this.pendingRoute = '/notifications/0/false';
        }
        this.router.navigateByUrl(this.pendingRoute);
      }
    );
  }

  async sendFCMTokenToBackend(): Promise<void> {
    try {
      const { token } = await FCM.getToken();

      if (!token) {
        return;
      }

      const userData = await this.sqlite.getItem<DriverResponse>('meData');
      const driverId = userData?.driverId;

      if (!driverId) {
        return;
      }

      // Store FCM token locally
      await this.sqlite.setItem('fcmToken', {
        driverId,
        token
      });

      // Send FCM token to backend
      const payload = {
        deviceToken: token
      };

      this.apiService
        .post<any, any>(
          'userMobileDevice/InsertUserMobileDevice',
          payload
        )
        .subscribe({
          error: (error) => {
            console.error('Failed to save FCM token to backend:', error);
          }
        });

    } catch (error) {
      console.error('FCM token error:', error);

      if (Capacitor.getPlatform().toUpperCase() !== 'WEB') {
        throw error;
      }
    }
  }
}